import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
import Breadcrumb from "../common/breadcrumb";
import { getCartTotal } from "../../services";
import { removeFromCart, incrementQty, decrementQty } from '../../actions'
import ReactTooltip from 'react-tooltip';

import { portal, store } from '../../config';
class cartComponent extends Component {

    constructor(props) {
        super(props)
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    incrementQuantity(item, qty) {
        const { incrementQty } = this.props;
        console.log(item);
        if (item.stock <= 0 || item.qty + qty > item.stock) {
            toast.error(`Item ${item.name} is currently out of stock!`);
        } else if ((item.qty + qty) > item.max_order) {
            toast.error(`Maximum order for ${item.name} reached!`);
        } else if ((item.qty + qty) === item.max_order) {
            toast.warn(`Maximum order for ${item.name} reached!`);
            incrementQty(item, 1)
        } else {
            incrementQty(item, 1)
        }
    }

    render() {

        const { cartItems, symbol, total } = this.props;
        const details = cartItems.length > 0
            ? cartItems[0].shortDetails
            : '';
        const canCheckout = total > 0;
        return (
            <div>
                <Breadcrumb title={'Store'} />
                
                {cartItems.length > 0 ?
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    {
                                        store.event ?
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "20px 0px",
                                            marginBottom: "50px",
                                            backgroundImage: "linear-gradient(to bottom, #F8F8F8, #EEE)",
                                            borderRadius: "20px",
                                        }}
                                    >
                                        <div>
                                            <h3 style={{ textAlign: "center" }}>{store.event.name}</h3>
                                            <h4 style={{ textAlign: "center" }}>{store.event.date}</h4>
                                            <h4 style={{ textAlign: "center" }}>{store.event.time}</h4>
                                            <h4 style={{ textAlign: "center" }}>{store.event.location}</h4>
                                            <h5 style={{ textAlign: "center" }}><a target="_blank" href={store.event.details}>Click here for event details</a></h5>
                                        </div>
                                    </div> : null
                                    }
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col" className="one">{portal.images}</th>
                                                {/* <th scope="col">event</th> */}
                                                <th scope="col">product name</th>
                                                <th scope="col">quantity</th>
                                                <th scope="col">price</th>
                                                {/* <th scope="col">discount</th> */}
                                                <th scope="col">total</th>
                                            </tr>
                                        </thead>
                                        {cartItems.map((item, index) => {
                                            const outOfStock = item.stock <= 0;
                                            const canAddMore = item.qty < item.stock && item.qty < item.max_order;
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td className="one">
                                                            <div data-tip={`<img style="width:400px;height:400px;object-fit:cover;" src='${item.variants[0].images}'/>`} data-html={true}>
                                                                <img style={{width: '100px', height: '100px', objectFit: 'cover'}} src={`${item.variants[0].images}`} alt=""/>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            
                                                            <h4><strong>{item.name}</strong></h4>
                                                            <h6>{item.shortDetails}</h6>
                                                            
                                                            <div className="mobile-cart-content row">
                                                                <div className="col-xs-3">
                                                                    <h2>{symbol}{item.price}</h2>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="qty-box">
                                                                <div className="input-group">
                                                                    <span className={"input-group-prepend" + (outOfStock ? ' out-of-stock': '')}>
                                                                        <button type="button" className="btn quantity-left-minus" onClick={() => this.props.decrementQty(item.id)} data-type="minus" data-field="" disabled={outOfStock}>
                                                                            <i className="fa fa-angle-left"></i>
                                                                        </button>
                                                                    </span>
                                                                    <input type="text" name="quantity" value={item.qty} className={"form-control input-number"+ (outOfStock ? ' out-of-stock': '')} disabled={outOfStock}/>

                                                                    <span className={`input-group-prepend ${outOfStock || !canAddMore ? ' out-of-stock': ''}`}>
                                                                        <button className="btn quantity-right-plus" onClick={() => this.incrementQuantity(item, 1)} data-type="plus" disabled={outOfStock || !canAddMore}>
                                                                            <i className="fa fa-angle-right"></i>
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="mobile-cart-content row">
                                                                {/* <div className="col-xs-3">
                                                                    <div className="qty-box">
                                                                        <div className="input-group">
                                                                            <span className="input-group-prepend">
                                                                                <button type="button" className="btn quantity-left-minus" onClick={() => this.props.decrementQty(item.id)} data-type="minus" data-field="">
                                                                                    <i className="fa fa-angle-left"></i>
                                                                                </button>
                                                                            </span>
                                                                            <input type="text" name="quantity" value={item.qty} className="form-control input-number" />

                                                                            <span className="input-group-prepend">
                                                                                <button className="btn quantity-right-plus" onClick={() => this.props.incrementQty(item, 1)} data-type="plus" disabled={(item.qty >= item.stock) ? true : false}>
                                                                                    <i className="fa fa-angle-right"></i>
                                                                                </button>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">{symbol}{parseFloat(item.sum,10).toFixed(2)}</h2>
                                                                </div>
                                                                {
                                                                    /* <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                    <a href="#" className="icon" onClick={() => this.props.removeFromCart(item)}>
                                                                    <i className="icon-close"></i>
                                                                    </a>
                                                                    </h2>
                                                                    </div> */
                                                                }
                                                            </div>


                                                        </td>
                                                        <td>
                                                            <h2>{symbol}{(item.price)}</h2>
                                                            {(item.qty >= item.stock) ? 'out of Stock' : ''}
                                                        </td>

                                                        {/* <td>
                                                    <a href="#" className="icon" onClick={() => this.props.removeFromCart(item)}>
                                                        <i className="fa fa-times"></i>
                                                    </a>
                                                </td> */}
                                                        {/* <td><h2>{symbol}{(item.discount)}</h2></td> */}
                                                        <td><h2 className="td-color">{symbol}{parseFloat(item.sum,10).toFixed(2)}</h2></td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table>
                                    <table className="table cart-table table-responsive-md">
                                        <tfoot>
                                            <tr>
                                                <td>total price :</td>
                                                <td><h2>{symbol}{parseFloat(total, 10).toFixed(2)} </h2></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <div className="row cart-buttons">
                                <div className="col-6">
                                    {/* <Link to={`${process.env.PUBLIC_URL}/left-sidebar/collection`} className="btn btn-solid">continue shopping</Link> */}
                                </div>
                                <div className="col-6">
                                    {
                                        canCheckout ?
                                            <Link to={`/checkout`} className="btn btn-solid" >check out</Link>
                                            : <button className="btn btn-solid" disabled>check out</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/icon-empty-cart.png`} className="img-fluid mb-4" alt="" />
                                            <h3>
                                                <strong>Your Cart is Empty</strong>
                                            </h3>
                                            <h4>Explore more shortlist some items.</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    cartItems: state.cartList.cart,
    symbol: state.data.symbol,
    total: getCartTotal(state.cartList.cart)
})

export default connect(
    mapStateToProps,
    { removeFromCart, incrementQty, decrementQty }
)(cartComponent)